import { createFetcher, objToStr } from './createFetcher';

/*
  Exporting commonly used communication methods
 */

const appendApiRoot = url => `${API_ROOT}${url}`;

export const get = (url, opts) => createFetcher(appendApiRoot(url), opts);
export const patch = (url, body, opts, headers = {}, defaultHeaders = true) =>
  createFetcher(appendApiRoot(url), { method: 'PATCH', body: objToStr({ ...body }), ...opts }, headers, defaultHeaders);
export const post = (url, body, opts) =>
  createFetcher(appendApiRoot(url), { method: 'POST', body: objToStr({ ...body }), ...opts });
export const put = (url, body, opts, headers = {}) =>
  createFetcher(appendApiRoot(url), { method: 'PUT', body: objToStr({ ...body }), ...opts }, headers);
export const del = (url, opts, headers = {}) =>
  createFetcher(appendApiRoot(url), { method: 'DELETE', ...opts }, headers);
